import React, { createContext, ReactNode } from "react";
import { Auth0Provider } from "@auth0/auth0-react";

export const AuthContext = createContext(null);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  return (
    <Auth0Provider
      domain={process.env.VITE_APP_AUTH0_DOMAIN as string}
      clientId={process.env.VITE_APP_AUTH0_CLIENT_ID as string}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.VITE_APP_AUTH0_AUDIENCE as string,
        scope: "openid profile email read:protected_resource",
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthContext;
